import { connect } from "react-redux";
import { Container } from "./style";

const Card = ({ className, style, children, theme, onClick }) => {
  const handleClick = () => {
    onClick && onClick();
  };
  return (
    <Container
      className={`direction-rtl ${className}`}
      style={style}
      theme={theme}
      onClick={handleClick}
    >
      {children}
    </Container>
  );
};

const mapStateToPtops = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToPtops, false)(Card);
